module.exports = __webpack_public_path__ + "assets/img/19_853_big.dcd11685.jpg";